import {
  BASE_NEW_POLICY_PATH,
  NewPolicyRoutes,
  getNewPolicyPath,
} from "@routing/paths";

export const drawerNavigationItems = [
  {
    name: "Product",
    paths: [
      `/${BASE_NEW_POLICY_PATH}`,
      getNewPolicyPath(NewPolicyRoutes.SELECT_PRODUCT),
    ],
  },
  {
    name: "Home Details",
    paths: [
      getNewPolicyPath(NewPolicyRoutes.UNIT_COUNT),
      getNewPolicyPath(NewPolicyRoutes.HOME_ADDRESS),
      getNewPolicyPath(NewPolicyRoutes.HOME_DETAILS),
    ],
  },
  {
    name: "Personal Details",
    paths: [getNewPolicyPath(NewPolicyRoutes.PERSONAL_DETAILS)],
  },
  {
    name: "Personalized Quotes",
    paths: [
      getNewPolicyPath(NewPolicyRoutes.PERSONALIZED_QUOTES),
      getNewPolicyPath(NewPolicyRoutes.EXTRA_COVERAGES),
    ],
  },
  {
    name: "Underwriting",
    paths: [
      getNewPolicyPath(NewPolicyRoutes.UNDERWRITING_QUESTIONS),
      getNewPolicyPath(NewPolicyRoutes.CLAIMS_CHECK),
      getNewPolicyPath(NewPolicyRoutes.CLAIMS_LIST),
    ],
  },
  {
    name: "Policy Summary",
    paths: [
      getNewPolicyPath(NewPolicyRoutes.POLICY_SUMMARY),
      getNewPolicyPath(NewPolicyRoutes.CUSTOMIZE_POLICY),
    ],
  },
  {
    name: "Checkout",
    paths: [
      getNewPolicyPath(NewPolicyRoutes.CHECKOUT),
      getNewPolicyPath(NewPolicyRoutes.CONGRATULATIONS),
    ],
  },
];
